/**
 * Fresh Coast — Age gate interactions
 * Boot (cookie check / no-flash reveal) happens in an inline script in
 * snippets/fc-age-gate.liquid; by the time this deferred file runs the
 * gate is either gone (verified visitor) or visible and scroll-locked.
 *
 * Motion is CSS-driven (fc-age-gate.css) so nothing here depends on GSAP.
 */

(function () {
  'use strict';

  var gate = document.getElementById('fc-age-gate');
  if (!gate || gate.hidden) return;

  var REDUCED =
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    document.documentElement.classList.contains('fc-motion-reduced');

  var askPanel = gate.querySelector('[data-fc-age-panel="ask"]');
  var denyPanel = gate.querySelector('[data-fc-age-panel="deny"]');
  var yesBtn = gate.querySelector('[data-fc-age-yes]');
  var noBtn = gate.querySelector('[data-fc-age-no]');
  var backBtn = gate.querySelector('[data-fc-age-back]');

  function setCookie() {
    var days = parseInt(gate.getAttribute('data-cookie-days'), 10);
    if (!days || days < 1) days = 30;
    var cookie = 'fc_age_ok=1; max-age=' + days * 86400 + '; path=/; SameSite=Lax';
    if (window.location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  function focusFirst(el) {
    if (el && typeof el.focus === 'function') {
      el.focus({ preventScroll: true });
    }
  }

  /* Panel swap: blur-fade the old panel out, then show the new one —
     its .fc-age-gate__reveal children re-run their CSS entrance because
     display:none resets animations. Reduced motion swaps instantly. */
  function swapPanels(from, to, headlineId, focusTarget) {
    var doSwap = function () {
      from.classList.remove('is-exiting');
      from.hidden = true;
      to.hidden = false;
      gate.setAttribute('aria-labelledby', headlineId);
      focusFirst(focusTarget);
    };

    if (REDUCED) {
      doSwap();
      return;
    }

    var done = false;
    var finish = function () {
      if (done) return;
      done = true;
      from.removeEventListener('animationend', finish);
      doSwap();
    };
    from.addEventListener('animationend', finish);
    from.classList.add('is-exiting');
    window.setTimeout(finish, 420); /* safety net if animationend never fires */
  }

  function unlock() {
    document.documentElement.classList.remove('fc-age-gate-open');
  }

  function enter() {
    setCookie();
    if (REDUCED) {
      unlock();
      gate.remove();
      return;
    }
    gate.addEventListener('transitionend', function onEnd(event) {
      if (event.target !== gate) return;
      gate.removeEventListener('transitionend', onEnd);
      gate.remove();
    });
    gate.classList.add('is-leaving');
    unlock();
    window.setTimeout(function () {
      if (gate.parentNode) gate.remove();
    }, 600);
  }

  if (yesBtn) yesBtn.addEventListener('click', enter);

  if (noBtn && denyPanel) {
    noBtn.addEventListener('click', function () {
      swapPanels(askPanel, denyPanel, 'fc-age-gate-deny-headline', gate.querySelector('[data-fc-age-exit]'));
    });
  }

  if (backBtn && askPanel) {
    backBtn.addEventListener('click', function () {
      swapPanels(denyPanel, askPanel, 'fc-age-gate-headline', yesBtn);
    });
  }

  /* Focus management: initial focus on the primary action, trap Tab
     inside the gate, and swallow Escape — this is a legal gate, not a
     dismissable dialog. */
  focusFirst(yesBtn);

  function focusables() {
    var nodes = gate.querySelectorAll('button, [href]');
    return Array.prototype.filter.call(nodes, function (node) {
      return node.offsetParent !== null && !node.disabled;
    });
  }

  document.addEventListener('keydown', function (event) {
    if (!gate.isConnected) return;

    if (event.key === 'Escape') {
      event.preventDefault();
      return;
    }

    if (event.key !== 'Tab') return;

    var items = focusables();
    if (!items.length) return;

    var first = items[0];
    var last = items[items.length - 1];
    var active = document.activeElement;

    if (!gate.contains(active)) {
      event.preventDefault();
      focusFirst(first);
    } else if (event.shiftKey && active === first) {
      event.preventDefault();
      focusFirst(last);
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      focusFirst(first);
    }
  });
})();
